import {
  setIsDybFeatureFlagEnabled,
  setIsSwjFlagEnabled,
  setJackpotData,
} from '@/store/actions';

export const dispatchSWJData = (swjData, features) => {
  const featureValues = Object.values(features ?? {});

  setJackpotData(swjData);
  setIsDybFeatureFlagEnabled(featureValues.includes('double_your_bet'));
  setIsSwjFlagEnabled(featureValues.includes('swj_module'));
};
